<template>
    <div>
        <modal
        class="new-modal-default"
        :name="modal_name"
        transition="nice-modal-fade"
        :delay="100"
        :width="1000"
        :height="600"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="false"
        style="pointer-events:inherit !important" 
        v-bind:click-to-close="false"
        >
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div></div>
                    <div>
                        <span class="v-modal-dialog-title v-modal-title">{{edit_create}} AN EVENT</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideCreateEvent"></span>
                    </div>
                </div>
                <div class="v-modal-body">
                    <div class="v-modal-layout">
                        <div class="mt-5">
                            <p class="fw-600 mb-5" style="font-size: 15px;">Event Details</p>
                            <div class="d-flex justify-content-between flex-wrap">
                                <div style="min-width: 22em; max-width: 22em; position: relative;">
                                    <span>Event Name <span class="text-danger">*</span></span>
                                    <textarea-autosize
                                        class="bg-transparent px-2 pt-1 pb-6 mt-1"
                                        v-model="eventData.name"
                                        placeholder="Enter Text Here.."
                                        :min-height="80"
                                        :max-height="80"
                                        @input="is_event_name = false"
                                        maxlength="100"
                                        data-vv-scope="profile_data"
                                        data-vv-as="About"
                                        name="event_name"
                                        style="border: solid 1px #d7dae2 !important;border-radius: 5px!important;text-transform: capitalize;color: #000000;width: 100%;"
                                    />
                                    <span class="editcharacter-count text-grey mr-2" style="right: 0;">{{100 - eventData.name.length}}/100</span>
                                    <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-if="is_event_name">Event Name is Required</span>
                                </div>
                                <div style="min-width: 22em; max-width: 22em;">
                                    <span class="mb-1">Event Type <span class="text-danger">*</span></span>
                                    <multiselect
                                        class="diginew-multiselect-lightgrey no-default-icon down-arrow mt-1"
                                        placeholder="Select Event Type"
                                        v-model="eventData.event_type"
                                        :clearable="false"
                                        :filterable="true"
                                        name="event_type"
                                        :options="['Anniversary', 'Business Event', 'Conference', 'Seminar', 'Workshop']"
                                        v-validate="'required'"
                                    >
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">List is Empty</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                    <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('event_type')">Event Type is Required</span>
                                </div>
                                <div style="min-width: 22em; max-width: 22em; position: relative;">
                                    <span>Event Description</span>
                                    <textarea-autosize
                                        class="bg-transparent px-2 pt-1 pb-6 mt-1"
                                        v-model="eventData.description"
                                        placeholder="Enter Text Here.."
                                        :min-height="80"
                                        :max-height="80"
                                        maxlength="100"
                                        data-vv-scope="profile_data"
                                        data-vv-as="About"
                                        name="about"
                                        style="border: solid 1px #d7dae2 !important;border-radius: 5px!important;text-transform: capitalize;color: #000000;width: 100%;"
                                    />
                                    <span class="editcharacter-count text-grey mr-2">{{100 - eventData.description.length}}/100</span>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between flex-wrap mt-15">
                            <div style="min-width: 22em; max-width: 22em;">
                                <p class="fw-600" style="font-size: 15px;">Schedule <span class="text-danger">*</span></p>
                                <div class="d-flex justify-content-between flex-wrap">
                                    <div class="mt-4" style="width: 50%;">
                                        <span>Event Start Date</span>
                                        <date-picker
                                            class="fullBorderCalendar mx-left calendar-edit-per mt-1"
                                            format="YYYY-MM-DD"
                                            v-model="eventData.event_schedule.start_date"
                                            :not-after="eventData.event_schedule.end_date"
                                            lang="en"
                                            :clearable="false"
                                            v-validate="'required'"
                                            name="event_schedule_start_date"
                                            value-type="format"
                                            :editable="false"
                                            type="date"
                                            confirm
                                            confirm-text="APPLY"
                                        ></date-picker>
                                        <span class="invalid-feedback-form text-danger mt-0" v-show="errors.has('event_schedule_start_date')">Start Date is required.</span>
                                    </div>
                                    <div v-if="!eventData.event_schedule.all_day" class="mt-4" style="width: 40%;">
                                        <span>Start Time</span>
                                        <el-select v-model="eventData.event_schedule.start_time" style="border-radius: 6px;border: 0.6px solid #d7dae2 !important;" 
                                        placeholder="Start Time" :popper-append-to-body="false">
                                            <el-option
                                                v-for="(item, index) in time_format"
                                                :key="index"
                                                :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between flex-wrap">
                                    <div class="mt-4" style="width: 50%;">
                                        <span>Event End Date</span>
                                        <date-picker
                                            class="fullBorderCalendar mx-left calendar-edit-per mt-1"
                                            format="YYYY-MM-DD"
                                            v-model="eventData.event_schedule.end_date"
                                            :not-before="eventData.event_schedule.start_date"
                                            lang="en"
                                            v-validate="'required'"
                                            name="event_schedule_end_date"
                                            :clearable="false"
                                            :editable="false"
                                            value-type="format"
                                            type="date"
                                            confirm
                                            confirm-text="APPLY"
                                        ></date-picker>
                                        <span class="invalid-feedback-form text-danger mt-0" v-show="errors.has('event_schedule_end_date')">End Date is required.</span>
                                    </div>
                                    <div v-if="!eventData.event_schedule.all_day" class="mt-4" style="width: 40%;">
                                        <span>End Time</span>
                                        <el-select v-model="eventData.event_schedule.end_time" style="border-radius: 6px;border: 0.6px solid #d7dae2 !important;" 
                                        placeholder="End Time" :popper-append-to-body="false">
                                            <el-option
                                                v-for="(item, index) in time_format"
                                                :key="index"
                                                :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="d-flex w-100 mt-8">
                                        <input v-model="eventData.event_schedule.all_day" type="checkbox" />
                                        <span class="ml-2">All Day</span>
                                    </div>
                                </div>
                            </div>
                            <div style="min-width: 22em; max-width: 22em;">
                                <p class="fw-600" style="font-size: 15px;">Location</p>
                                <div class="d-flex" style="margin-top: 3.7em;">
                                    <div class="gMap" style="position:relative;width:100%;">
                                        <gmap-autocomplete
                                            class="inputFieldNoBorder mt-0"
                                            id="autocompleteInput"
                                            placeholder="Search Location"
                                            @place_changed="setPlace"
                                            :value="locationVmodel"
                                            v-model="locationVmodel"
                                            style="padding: 8px 32px 8px 18px !important; height: 40px;"
                                        ></gmap-autocomplete>
                                        <img
                                            src="/static/images/images-new-theme/icons/marker_pin.svg"
                                            style="position: absolute;right: 12px;bottom: 12px;"
                                        />
                                    </div>
                                    <div class="form-group gMap ml-4 pt-0" style="cursor: pointer;" @click="getLocation">
                                        <img src="/static/images/images-new-theme/icons/GPS 2.svg" style="height: 40px;" />
                                    </div>
                                </div>
                            </div>
                            <div style="min-width: 22em; max-width: 22em;">
                                <p class="fw-600" style="font-size: 15px;">Invite</p>
                                <div class="d-flex flex-column mt-6" style="position: relative;">
                                    <span>Invite Someone</span>
                                    <multiselect
                                        class="diginew-multiselect-lightgrey greyblack no-default-icon mt-1"
                                        placeholder="Invite"
                                        v-model="eventData.invitees"
                                        :multiple="true"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        :options="inviteOptions"
                                        :loading="is_loading_invite"
                                        @open="getInvitees"
                                        @search-change="getInvitees"
                                        label="full_name"
                                        trackBy="id"
                                    >
                                        <!-- <template slot="caret">
                                            <div @mousedown.prevent.stop="toggle()" class="multiselect__select">
                                                <i class="icon-account-plus" style="color: #cdd2da;"></i>
                                            </div>
                                        </template> -->
                                        <template slot="option" slot-scope="props" class="d-flex">
                                            {{ props.option.full_name ? props.option.full_name : props.option.email_id }}
                                        </template>
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfListInvitees" />
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">List is Empty</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                    <i class="icon-account-plus" style="color: #cdd2da; position: absolute; right: 0; margin-top: 30px; margin-right: 10px;"></i>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-15">
                            <div class="col-lg-4 col-md-4 col-sm-12" >
                                <p class="fw-600" style="font-size: 15px;">Repeat</p>
                                <div class="mt-4">
                                    <span>Repeat Option</span>
                                    <div class="mt-1">
                                        <multiselect
                                            class="diginew-multiselect-lightgrey text-capitalize no-default-icon down-arrow"
                                            v-model="event_repeat_option"
                                            :clearable="false"
                                            :filterable="true"
                                            :options="['Do Not Repeat', 'Daily', 'Weekly', 'Monthly', 'Yearly']"
                                        >
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">List is Empty</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                        <div v-if="event_repeat_option == 'Weekly'" class="d-flex align-items-center flex-wrap mt-2">
                                            <div class="d-flex align-items-center mt-2 mr-2">
                                                <input type="checkbox" id="mon" name="mon" v-model="repeat_day_mon">
                                                <label style="font-size: 14px;" class="mb-0 ml-2" :class="{'text-secondary':repeat_day_mon}" for="mon">Mon</label>
                                            </div>
                                            <div class="d-flex align-items-center mt-2 mr-2">
                                                <input type="checkbox" id="tue" name="tue" v-model="repeat_day_tue">
                                                <label style="font-size: 14px;" class="mb-0 ml-2" :class="{'text-secondary':repeat_day_tue}" for="tue">Tue</label>
                                            </div>
                                            <div class="d-flex align-items-center mt-2 mr-2">
                                                <input type="checkbox" id="wed" name="wed" v-model="repeat_day_wed">
                                                <label style="font-size: 14px;" class="mb-0 ml-2" :class="{'text-secondary':repeat_day_wed}" for="wed">Wed</label>
                                            </div>
                                            <div class="d-flex align-items-center mt-2 mr-2">
                                                <input type="checkbox" id="thu" name="thu" v-model="repeat_day_thu">
                                                <label style="font-size: 14px;" class="mb-0 ml-2" :class="{'text-secondary':repeat_day_thu}" for="thu">Thu</label>
                                            </div>
                                            <div class="d-flex align-items-center mt-2 mr-2">
                                                <input type="checkbox" id="fri" name="fri" v-model="repeat_day_fri">
                                                <label style="font-size: 14px;" class="mb-0 ml-2" :class="{'text-secondary':repeat_day_fri}" for="fri">Fri</label>
                                            </div>
                                            <div class="d-flex align-items-center mt-2 mr-2">
                                                <input type="checkbox" id="sat" name="sat" v-model="repeat_day_sat">
                                                <label style="font-size: 14px;" class="mb-0 ml-2" :class="{'text-secondary':repeat_day_sat}" for="sat">Sat</label>
                                            </div>
                                            <div class="d-flex align-items-center mt-2 mr-2">
                                                <input type="checkbox" id="sun" name="sun" v-model="repeat_day_sun">
                                                <label style="font-size: 14px;" class="mb-0 ml-2" :class="{'text-secondary':repeat_day_sun}" for="sun">Sun</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12">
                                <div class="mt-11" v-if="event_repeat_option != 'Do Not Repeat' && event_repeat_option != ''">
                                    <div class="mb-1">End Date</div>
                                    <div class="">
                                        <div class="d-flex align-items-center mr-3">
                                            <div class="d-flex align-items-center">
                                                <input type="radio" id="repeat_never" name="repeat_never_date" v-model="repeat_never_date" value="never">
                                                <label class="mb-0 ml-2" for="repeat_never">Never</label>
                                            </div>
                                            <div class="d-flex align-items-center ml-3">
                                                <input type="radio" id="repeat_date" name="repeat_never_date" v-model="repeat_never_date" value="date">
                                                <label class="mb-0 ml-2" for="repeat_date">Select Date</label>
                                            </div>
                                        </div>
                                        <div v-if="repeat_never_date == 'date'">
                                            <div class="mt-2">Select End Date</div>
                                            <date-picker
                                                class="fullBorderCalendar mx-left calendar-edit-per mt-1"
                                                format="YYYY-MM-DD"
                                                v-model="eventData.repeat.end_date"
                                                :not-before="new Date()"
                                                lang="en"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                confirm
                                                confirm-text="APPLY"
                                            ></date-picker>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12">
                                <p class="fw-600" style="font-size: 15px;">Reminder</p>
                                <div class="mt-7">
                                    <div class="mt-4">
                                        <div class="d-flex align-items-center mt-1" v-for="(reminder,index) in eventData.remind_before" :key="index">
                                            <span>Before</span>
                                            <input class="text-center mx-2 pr-5" v-model="reminder.number" type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" style="min-height: 40px; width: 55px; border: solid 1px #d7dae2; border-radius: 5px;" />
                                            <div class="d-flex flex-column" style="position: absolute; margin-left: 82px;">
                                                <i class="icon icon-arrow-down-drop pointer" style="transform: rotate(180deg); line-height: 12px;" @click="reminder.number++"></i>
                                                <i class="icon icon-arrow-down-drop pointer" style="line-height: 12px;" @click="reminder.number != 0 ? reminder.number-- : ''"></i>
                                            </div>
                                            <multiselect
                                                class="diginew-multiselect-lightgrey no-default-icon down-arrow"
                                                v-model="reminder.gap"
                                                :clearable="false"
                                                :filterable="true"
                                                :options="['Days', 'Minutes', 'Hours']"
                                            >
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">List is Empty</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                            <i v-if="index != 0" class="icon-minus-circle ml-1" style="color: #e82828; font-size: 16px;" @click="deleteRemindBefore(index)"></i>
                                            <i class="icon-plus-circle ml-1" :class="index == 0 && eventData.remind_before.length > 1 ? 'ml-6' : 'ml-0'" style="color: #005dae; font-size: 16px;" @click="addRemindBefore"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="v-modal-dialog-actions">
                    <div class="d-flex justify-content-center align-items-center my-6">
                        <button class="btn btn-new-danger btn-smm mr-3" @click="hideCreateEvent">CANCEL</button>
                        <button class="btn btn-new-green btn-smm ml-3" :disabled="save_create_btn_hide" @click="saveCreateEvent">SAVE</button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import VueTextareaAutosize from "vue-textarea-autosize";
import axios from "axios";
import globals from './globals';
import profile from './mixins/profile';
export default {
    data() {
        const value2date = (dateRange) => {
            const date = new Date(dateRange)
            return dateRange ? new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000) : null
        }
        const date2value = (date) => {
            return date ? new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000) : null
        }
        return {
            valueType: {
                value2date,
                date2value
            },
            eventData: {
                description: "",
                event_schedule: {
                    all_day: false,
                    end_date: "",
                    start_date: "",
                    end_time: "",
                    start_time: "",
                },
                event_type: "",
                invitees: [],
                location: {
                    city: "",
                    country: "",
                },
                name: "",
                remind_before: [
                    {
                        gap: "",
                        number: 0,
                    },
                ],
                repeat: {
                    end_date: "",
                },
            },
            time_format: [
                '00:00',
                '00:30',
                '01:00',
                '01:30',
                '02:00',
                '02:30',
                '03:00',
                '03:30',
                '04:00',
                '04:30',
                '05:00',
                '05:30',
                '06:00',
                '06:30',
                '07:00',
                '07:30',
                '08:00',
                '08:30',
                '09:00',
                '09:30',
                '10:00',
                '10:30',
                '11:00',
                '11:30',
                '12:00',
                '12:30',
                '13:00',
                '13:30',
                '14:00',
                '14:30',
                '15:00',
                '15:30',
                '16:00',
                '16:30',
                '17:00',
                '17:30',
                '18:00',
                '18:30',
                '19:00',
                '19:30',
                '20:00',
                '20:30',
                '21:00',
                '21:30',
                '22:00',
                '22:30',
                '23:00',
                '23:30',
            ],
            locationVmodel: "",
            inviteOptions: [],
            is_loading_invite:false,
            search_key: "",
            is_event_name: false,
            event_repeat_option: 'Do Not Repeat',
            repeat_day_mon: false,
            repeat_day_tue: false,
            repeat_day_wed: false,
            repeat_day_thu: false,
            repeat_day_fri: false,
            repeat_day_sat: false,
            repeat_day_sun: false,
            repeat_never_date: 'date',
            save_create_btn_hide: false
        }
    },
    props: ["modal_name", "edit_create", "event_id"],
    components: {
        VueTextareaAutosize
    },
    mixins: [profile],
    methods: {
        clearAll() {
            this.eventData = {
                description: "",
                event_schedule: {
                    all_day: false,
                    end_date: "",
                    start_date: "",
                },
                event_type: "",
                invitees: [],
                location: {
                    city: "",
                    country: "",
                },
                name: "",
                remind_before: [
                    {
                        gap: "",
                        number: 0,
                    },
                ],
                repeat: {
                    end_date: "",
                },
            };
            this.locationVmodel = "";
            this.inviteOptions = [];
            this.search_key = "";
        },
        setPlace(place) {
            this.locationVmodel = place.formatted_address;
            let address = place.formatted_address.split(", ");
            this.eventData.location.city = address[address.length - 3];
            this.eventData.location.country = address[address.length - 1];
        },
        checkName(){
            if(this.eventData.name){
                this.is_event_name = false
            }
            else{
                this.is_event_name = true
            }
        },
        getLocation() {
            if (navigator.geolocation) {
                // timeout at 60000 milliseconds (60 seconds)
                var options = {
                enableHighAccuracy: false,
                timeout: 30000, // milliseconds (30 seconds)
                maximumAge: 600000
                }; // milliseconds (10 minutes)
                navigator.geolocation.getCurrentPosition(
                this.showLocation,
                this.errorHandler,
                options
                );
            } else {
                alert("Sorry, browser does not support geolocation!");
            }
        },
        showLocation(position) {
            let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
            let calllatlong = axios.create();
            delete calllatlong.defaults.headers.common['Authorization'];
            calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latlongvalue + "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
            .then(response => {
                let address = response.data.results[0].formatted_address.split(", ");
                this.eventData.location.city = address[address.length - 3];
                this.eventData.location.country = address[address.length - 1];
                this.locationVmodel = response.data.results[0].formatted_address;
            }).catch(e => {
                // this.errors.push(e)
            });
        },
        errorHandler(err) {
            if (err.code == 1) {
                // alert("Error: Access is denied!");
            } else if (err.code == 2) {
                // alert("Error: Position is unavailable!");
            }
        },
        addRemindBefore() {
            this.eventData.remind_before.push({
                gap: "",
                number: 0,
            });
        },
        deleteRemindBefore(index) {
            this.eventData.remind_before.splice(index,1);
        },
        async getInvitees(key) {
            this.is_loading_invite = true
            if (key) {
                this.search_key = key;
            }
            let params = {
                limit: 10,
                skip: 0,
                search_key: this.search_key,
            };
            let res = await this.$http.get(globals.AUTH_SERVICE + `/profile/users/dropdown?skip=${params.skip}&limit=${params.limit}&search_key=${params.search_key}`);
            if (res.data.status_id == 1) {
                this.inviteOptions = res.data.response;
                this.is_loading_invite = false
            }
        },
        async reachedEndOfListInvitees(reached) {
            if (reached && this.inviteOptions.length >= 10) {
                this.is_loading_invite = true
                let params = {
                    limit: 10,
                    skip: this.inviteOptions.length,
                    search_key: this.search_key,
                };
                let res = await this.$http.get(globals.AUTH_SERVICE + `/profile/users/dropdown?skip=${params.skip}&limit=${params.limit}&search_key=${params.search_key}`);
                if (res.data.status_id == 1) {
                    res.data.response.forEach(x => {
                        this.inviteOptions.push(x);
                    });
                    this.is_loading_invite = false
                }
            }
        },
        hideCreateEvent() {
            this.clearAll();
            setTimeout(() => {
                this.$modal.hide(this.modal_name);
            }, 500);
            this.$emit("hideCreateEvent");
        },
        async saveCreateEvent() {
            this.$validator.validateAll().then( async result => {
                if(this.eventData.name == '') {
                    this.is_event_name = true
                }
                else {
                    this.is_event_name = false
                }
                if (result && this.is_event_name == false) {
                    this.save_create_btn_hide = true;
                    let params = this.createEventJson;
                    if (!params.end_date && !params.start_date && !params.all_day) {
                        params.params.end_date = '';
                        params.params.start_date = '';
                    }
                    if (params.repeat.repeat_option != 'Weekly') {
                        params.repeat.options = [];
                    } else {
                        if(this.repeat_day_mon) {
                            params.repeat.options.push('Mon');
                        }
                        if(this.repeat_day_tue) {
                            params.repeat.options.push('Tue');
                        }
                        if(this.repeat_day_wed) {
                            params.repeat.options.push('Wed');
                        }
                        if(this.repeat_day_thu) {
                            params.repeat.options.push('Thu');
                        }
                        if(this.repeat_day_fri) {
                            params.repeat.options.push('Fri');
                        }
                        if(this.repeat_day_sat) {
                            params.repeat.options.push('Sat');
                        }
                        if(this.repeat_day_sun) {
                            params.repeat.options.push('Sun');
                        }
                    }
                    if (params.reminder.length == 1 && !params.reminder[0].gap) {
                        params.reminder = [];
                    }
                    if(params.repeat.repeat_option == 'Do Not Repeat') {
                        delete params.repeat.end_date;
                        delete params.repeat.never;
                        delete params.repeat.options;
                    }
                    if(params.repeat.never == true && (params.repeat.repeat_option == 'Daily' || params.repeat.repeat_option == 'Monthly' || params.repeat.repeat_option == 'Yearly')) {
                        delete params.repeat.end_date;
                        delete params.repeat.options;
                    }
                    if(params.repeat.never == false && (params.repeat.repeat_option == 'Daily' || params.repeat.repeat_option == 'Monthly' || params.repeat.repeat_option == 'Yearly')) {
                        delete params.repeat.options;
                    }
                    if(params.repeat.repeat_option == 'Weekly' && params.repeat.never == true) {
                        delete params.repeat.end_date;
                    }
                    if(this.createEventJson.all_day == true) {
                        params.start_time = '00:00';
                        params.end_time = '00:00';
                    }
                    params.invitees = [...new Set(this.eventData.invitees.map(x => x.id))];
                    if(this.event_id.length) {
                        params.id = this.event_id;
                        params.user_id = this.loggedInUser.user_id;
                        let res = await this.updateEvents(params, this.event_id);
                        if (res.status_id == 1) {
                            setTimeout(() => {
                                this.$modal.hide(this.modal_name);
                            }, 500);
                            setTimeout(() => {
                                this.$emit('eventCreatedSuccess');
                            }, 500);
                        }
                    } else {
                        delete params.id
                        delete params.user_id
                        let res = await this.createEvents(params);
                        // this.clearAll();
                        if (res.status_id == 1) {
                            setTimeout(() => {
                                this.$modal.hide(this.modal_name);
                            }, 500);
                            this.$emit('eventCreatedSuccess');
                        }
                    }
                }
                else {

                }
            })
        },
        async getEventDataById() {
            try {
                let param = this.event_id;
                let response = await this.getEventsById(param);
                if(response.status_id == 1) {
                    let events_data = response.response;
                    this.eventData.event_schedule.start_date = events_data.start_date;
                    this.eventData.event_schedule.end_date = events_data.end_date;
                    this.eventData.event_schedule.start_time = events_data.start_time;
                    this.eventData.event_schedule.end_time = events_data.end_time;
                    this.eventData.name = events_data.event_name;
                    // this.eventData.id = events_data.id;
                    // this.eventData.id = events_data.id;
                    this.eventData.event_type = events_data.event_type;
                    this.eventData.description = events_data.description;
                    this.eventData.event_schedule.all_day = events_data.all_day;
                    this.locationVmodel = events_data.location;
                    this.eventData.invitees = events_data.invitees;
                    this.eventData.repeat.end_date = events_data.repeat.end_date ? events_data.repeat.end_date : '';
                    this.event_repeat_option = events_data.repeat.repeat_option;
                    this.repeat_never_date = events_data.repeat.never ? 'never' : 'date';
                    if(events_data.reminder.length) {
                        this.eventData.remind_before = events_data.reminder;
                    } else {
                        this.eventData.remind_before.push({
                            gap: "",
                            number: 0,
                        });
                    }
                    if(events_data.repeat.options.length) {
                        events_data.repeat.options.forEach(el=>{
                            if(el == 'Mon' || el == 'Monday') {
                                this.repeat_day_mon = true;
                            } else if(el == 'Tue' || el == 'Tuesday') {
                                this.repeat_day_tue = true;
                            } else if(el == 'Wed' || el == 'Wednesday') {
                                this.repeat_day_wed = true;
                            } else if(el == 'Thu' || el == 'Thursday') {
                                this.repeat_day_thu = true;
                            } else if(el == 'Sat' || el == 'Saturday') {
                                this.repeat_day_sat = true;
                            } else if(el == 'Sun' || el == 'Sunday') {
                                this.repeat_day_sun = true;
                            }
                        });
                    }
                }
            }
            catch(err) {
                // console.log(err);
            }
        }
    },
    mounted() {
        if(this.event_id.length) {
            this.getEventDataById();
        }
    },
    watch: {
        "eventData.all_day": function() {
            if (this.eventData.all_day) {
                this.eventData.start_date = new Date();
                this.eventData.end_date = new Date();
            }
        }
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        // account() {
        //     return this.$store.getters.account;
        // },
        // selectedCompany() {
        //     return this.$store.getters.selectedCompany;
        // },
        createEventJson() {
            return {
                reminder: this.eventData.remind_before,
                repeat: {
                    repeat_option: this.event_repeat_option,
                    never: this.repeat_never_date == 'date' ? false : true,
                    end_date: this.eventData.repeat.end_date,
                    options: []
                },
                event_name: this.eventData.name,
                event_type: this.eventData.event_type,
                description: this.eventData.description,
                start_date: this.eventData.event_schedule.start_date,
                end_date: this.eventData.event_schedule.end_date,
                start_time: this.eventData.event_schedule.start_time,
                end_time: this.eventData.event_schedule.end_time,
                location: this.eventData.location.city ? this.eventData.location.city+','+this.eventData.location.country : '',
                all_day: this.eventData.event_schedule.all_day,
                invitees: [],
                id: '',
                user_id: ''
            }
        }
    },
    created() {
        const dict = {
            custom: {

            }
        }
        this.$validator.localize('en', dict)
    }
}
</script>


// WEBPACK FOOTER //
// src/components/CreateEvent.vue